import { Grid, TextField } from "@mui/material";

/** A landline in the three boxes a government form prints: country code, area code, number. */
const PhonePartFields = ({ label, value, onChange }) => {
  const field = (key) => (event) => onChange({ ...value, [key]: event.target.value });

  return (
    <>
      <Grid item xs={6} sm={3}>
        <TextField
          label={`${label} country code`}
          size="small"
          fullWidth
          value={value.countryCode}
          onChange={field("countryCode")}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          label={`${label} area code`}
          size="small"
          fullWidth
          value={value.areaCode}
          onChange={field("areaCode")}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label={`${label} number`}
          size="small"
          fullWidth
          value={value.number}
          onChange={field("number")}
        />
      </Grid>
    </>
  );
};

export default PhonePartFields;
